import React from 'react';
import { Dialog } from '@mui/material';
import close from '../../assets/close.svg';

const StatusModal = ({ title, content, closeBtnText, onClose }: any) => {
    return (
        <Dialog
            open={true}
            onClose={() => onClose(false)}
            className='status-modal'
        >
            <div className='content'>
                <div
                    className='close-btn cursor-pointer'
                    onClick={() => onClose(false)}
                >
                    <img src={close} alt='' height={11} width={14} />
                </div>
                <div className='wrapper'>
                    <div className=''>
                        <h1 className='title green-lt-text'>{title}</h1>
                        <div>{content}</div>
                    </div>
                    <div className='action-container'>
                        <button
                            className='primary'
                            onClick={() => onClose(false)}
                            style={{fontSize: '21px'}}
                        >
                            {closeBtnText}
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default StatusModal;
